// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__ezCj8","title":"PrivacyPolicy_title__xYB9w"};